import { post } from '../Services/http';
import { catchError } from './Error.action';

export const closeMessageBanner = (messageId) => (
    dispatch
) => {
    return post(`/api/messagebanner/close`, messageId)
        .then((response) => response.json())
        .catch((ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
            throw ex;
        });
};


